/**
 * Accessibility for links.
 * @type {{attach: Drupal.behaviors.links.attach}}
 */
const $ = window.jQuery;

const documentsList = ["pdf", "txt", "doc", "docx", "xls", "xlsx", "ppt", "pptx"];

export default {
  attach: function (context, settings) {
    // const accessibleLinks_once = once('accessible-links-once', '.region-primary-menu .main-wrapper, .footer-wrapper', context);
    const accessibleLinks_once = once('accessible-links-once', 'body', context);

    $(accessibleLinks_once).each(function () {
      let _this = $(this);

      setTimeout(function() {
        _this.find('a').each(function() {
          let host = window.location.host;
          let $link = $(this);
          let labelText;
          let documentType;

          if (typeof $link.attr('href') !== 'undefined') {
            if (typeof $link.attr('aria-label') !== 'undefined') {
              labelText = $link.attr('aria-label');
            } else {
              labelText = $link.text().trim();
            }

            documentsList.forEach(function (item) {
              if ($link.attr('href').indexOf(item) === ($link.attr('href').length - 3)) {
                documentType = item;
              }
            });

            if ((($link.attr('href').indexOf('http') > -1) && ($link.attr('href').indexOf(host) === -1))
              && (!$link.hasClass('teaser-link')) && (!$link.hasClass('mms-teaser-link'))) {
              // Add aria-label and icon to external links and documents.
              // Exclude teasers, because they already are accessible.

              if ((typeof documentType !== 'undefined') && (documentType.length)) {
                labelText = labelText + ' (' + Drupal.t('Opens an external @type document', {'@type': documentType}) + ')';
              } else {
                labelText = labelText + ' (' + Drupal.t('Opens an external page') + ')';
              }

              $link.attr('aria-label', labelText);

              // Add external link icon to external links in text.
              if (($link.closest('.paragraph.text .paragraph__content').length)
                || ($link.closest('.paragraph.faq .faq_answer').length)
                || ($link.closest('.content-header__text .normal-page__teaser-text').length)) {

                $link.addClass('external-link');
                $link.append('<span class="external-link-icon"><i aria-hidden="true" class="fas fa-external-link"></i></span>');
              }
            } else if ((typeof documentType !== 'undefined') && (documentType.length)) {
              // Add aria-label links with documents.
              labelText = labelText + ' (' + Drupal.t('Opens a @type document', {'@type': documentType}) + ')';
              $link.attr('aria-label', labelText);
            }
          }
        });
      }, 2000);
    });
  },
}
